/**
 * Maaş çekirdeği için yardımcı fonksiyonlar.
 *
 * v2 (Faz 5.x): max avans artık GERÇEK ANLIK HAK EDİŞ üzerinden hesaplanır.
 * Sabit maaş varsayımı (× 0.5) kaldırıldı. maasHesapla() kullanılır:
 *   - Aylık personel: sabit maaş − eksik mesai kesintisi − cezalar − ...
 *   - Saatlik personel: çalışılan saat × ücret + ...
 * Borçlu ise (anlikNet ≤ 0) → max avans 0.
 *
 * Formül: max = (gerçek hak ediş × 0.5) − bu ay onaylı/ödenmiş avans toplamı
 *   gerçek hak ediş = anlikNet + odenmisAvansToplam (avansları geri ekle, çift düşme)
 */

import { personelAyAvanslari, type Avans } from './avans-service'
import { maasHesapla } from '@/lib/maas/maas-hesap'
import type { KullaniciPersonel } from '@/types'

/**
 * Bu ay personelin alabileceği maksimum avans.
 * Gerçek anlık hak edişin yarısından, mevcut onaylı/ödenmiş avanslar düşülür.
 */
export async function maxAvansTutari(
  personel: KullaniciPersonel,
  ay: string
): Promise<number> {
  const hesap = await maasHesapla(personel, ay)

  // anlikNet zaten ödenmiş avansları düşüyor; yarı maaş formülünde çift
  // düşmesin diye geri ekle → gerçek (avans hariç) anlık hak ediş.
  const gercekHakEdis = hesap.anlikNet + hesap.odenmisAvansToplam
  const yariHakEdis = gercekHakEdis * 0.5

  // Bu ay onaylı veya ödenmiş tüm avansları düş (henüz ödenmemiş onaylı olanlar da hesaba katılır)
  const buAyTalepler = await personelAyAvanslari(personel.id, ay)
  const dusulecek = buAyTalepler
    .filter((a: Avans) => a.durum === 'onaylandi' || a.durum === 'odendi')
    .reduce((acc, a) => acc + (a.onayTutari ?? a.talepTutari), 0)

  const max = yariHakEdis - dusulecek
  return Math.max(0, Math.floor(max))
}
